$(document).ready(function () {
  setTimeout(function () {
    $("#banner-slider").owlCarousel({
      margin: 0,
      loop: true,
      slideSpeed: 7000,
      paginationSpeed: 400,
      autoplay: true,
      nav: false,
      pagination: false,
      dots: false,
      navText: [
        "<img src='https://cdn.shopify.com/s/files/1/0879/6776/0691/files/Group_515783.svg?v=1715765252'>",
        "<img src='https://cdn.shopify.com/s/files/1/0879/6776/0691/files/Group_515781.svg?v=1715765253'>",
      ],
      responsive: {
        0: {
          items: 1,
        },
        480: {
          items: 1,
        },
        700: {
          items: 1,
        },
        1000: {
          items: 1,
        },
        1100: {
          items: 1,
        }
      }
    });
    
  }, 500);
   $('.feature-slider').slick({
  dots: false,
    arrow:true,
    infinite: true,
    autoplay: true,
    prevArrow: $('.prev'),
    nextArrow: $('.next'),
  speed: 300,
  slidesToShow: 4,
  slidesToScroll: 1,
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1,
        infinite: true
      }
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1
      }
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1
      }
    }
    // You can unslick at a given breakpoint now by adding:
    // settings: "unslick"
    // instead of a settings object
  ]
});

  // Load More button
  let productsOnPage = $("#product-grid");
  let nextUrl = productsOnPage.attr("data-next-url");
  let loadMoreBtn = $(".load-more-btn");
  let loadMoreSpinner = $(".load-more-spinner");
  $(".load-more-btn").click(function (e) {
    e.preventDefault();
    loadMoreBtn.hide();
    loadMoreSpinner.show();
    $.ajax({
      url: nextUrl,
      type: "GET",
      dataType: "html",
      success: function (nextPage) {
        loadMoreSpinner.hide();
        let newProducts = $(nextPage).find("#product-grid");
        productsOnPage.append(newProducts.html());
        let newUrl = newProducts.attr("data-next-url");
        nextUrl = newUrl;
        if (newUrl) {
          loadMoreBtn.show();
        }
      },
    });
  });
});
